module.exports = __webpack_public_path__ + "img/vote-number.2ec0cdb1.png";